// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.BrowserUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

const IPAD_LANDSCAPE_WIDTH = 1100;
const MOBILE_WIDTH = 1024;

/**
 * This utilities is for handling browser (close tab, open tab, open tab and print, etc)
 */
export default {
  /**
   * Open new tab
   * @param {string} url
   */
  openNewTab: function(url: string): Window {
    return window.open(url);
  },

  /**
   * Check mobile device
   * @return {Boolean} [description]
   */
  isMobileDevice: function(): boolean {
    return window.innerWidth <= MOBILE_WIDTH;
  },

  /**
   * Check is ipad device
   * @return {Boolean} [description]
   */
  isIpadDevice: function(): boolean {
    return window.innerWidth < IPAD_LANDSCAPE_WIDTH;
  },

  /**
   * Get screen size
   * @return {Object} [description]
   */
  getScreenSize: function(): any {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  },

  /**
   * Check if the current browser is IE
   */
  isIEBrowser: function(): boolean {
    return /(?:MSIE |Trident\/.*; rv:)(\d+)/.test(navigator.userAgent);
  },

   /**
   * Check if the current browser is Edge
   */
  isEdgeBrowser: function(): boolean {
    return ((navigator.userAgent).indexOf("Edge") > -1);
  },

   /**
   * Check if the current browser is Edge or IE
   */
  isIEOrEdgeBrowser: function(): boolean {
    return (this.isIEBrowser() || this.isEdgeBrowser());
  },

  /**
   * Check if the current browser is Chrome
   */
  isChromeBrowser: function(): boolean {
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  },

  /**
   * Check if the current browser is Safari
   */
  isSafariBrowser: function(): boolean {
    return /Safari/.test(navigator.userAgent) && /Apple/.test(navigator.vendor);
  },

  /**
   * Check if current browser support position sticky
   */
  isSupportSticky: function(): boolean {
    const testNode = document.createElement('div');
    return ['', '-webkit-', '-moz-', '-ms-'].some(prefix => {
      try {
        testNode.style.position = prefix + 'sticky';
      } catch (e) {}

      return testNode.style.position != '';
    });
  }
};



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.BrowserUtils.js